import { motion } from "framer-motion";
import { ROADMAP } from "@/data/site";
import { Reveal, SectionLabel } from "./Reveal";

export const Roadmap = () => (
  <section id="roadmap" className="relative bg-[#0b0f18] py-24 sm:py-36" data-testid="roadmap-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal><SectionLabel index="04">Quarterly plan</SectionLabel></Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-6 font-display text-4xl font-bold uppercase leading-[0.95] sm:text-6xl">
          The fiscal year <br /><span className="text-gold">of total domination</span>
        </h2>
      </Reveal>
      <div className="mt-16 border-t border-teal-400/20">
        {ROADMAP.map((r, i) => (
          <Reveal key={r.q} delay={i * 0.05}>
            <motion.div whileHover="hover" initial="rest" data-testid={`roadmap-${r.q.toLowerCase()}`}
              className="group relative grid gap-6 overflow-hidden border-b border-teal-400/20 py-10 md:grid-cols-[140px_1fr_1.2fr_auto] md:items-center">
              <motion.span variants={{ rest: { scaleX: 0 }, hover: { scaleX: 1 } }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                className="absolute inset-0 -z-0 origin-left bg-gradient-to-r from-amber-400/10 to-transparent" />
              <p className="relative font-display text-6xl font-black text-outline transition-colors duration-500 group-hover:text-amber-400">{r.q}</p>
              <h3 className="relative font-display text-2xl font-bold text-slate-50 sm:text-3xl">{r.title}</h3>
              <ul className="relative space-y-2">
                {r.items.map((it) => (
                  <li key={it} className="flex items-center gap-3 text-slate-300">
                    <span className="h-1.5 w-1.5 rotate-45 bg-amber-400" />{it}
                  </li>
                ))}
              </ul>
              <span className={`relative w-fit border px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] ${i === 0 ? "border-amber-400 text-amber-300" : "border-teal-400/30 text-teal-200"}`}>
                {r.status}
              </span>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
